<template>
  <L1>
    <div class="g3">
      <div>

      <div class="switchs">
        <div>點數發送</div>
        <div>
          <div class="switchslabel" label="每日自動發送"><switchBox :defaultValue="autoPointSend" @update="updateP('auto_send_point', 'autoPointSend',  $event)"/></div>
        </div>
      </div>
      <div class="switchs">
        <div>發送比例</div>
        <div>
          <div class="ratiobox" :style="{justifyContent: 'flex-start'}">消費金額滿 <inputNum :style="{width: '100px'}" :center="true"
            :defaultValue="pointratio" @input="pointratio=$event"/> 可換 <span class="highlight">1</span> 點</div>
            <SaveBtn v-if="pointratio!==pointratioOrg" @click="updateRatio"/>
        </div>
      </div>
      </div>
    <editCube :style="{justifyContent: 'flex-start'}" :title="'點數兌換須知'" :defaultValue="pointExchangeMustKnow" @save="update('pointExchangeMustKnow', $event)"/>
    <editCube :style="{justifyContent: 'flex-start'}" :title="'詳細使用說明'" :defaultValue="pointExchangeDirections" @save="update('pointExchangeDirections', $event)"/>
  </div>
  </L1>
</template>

<script>
import SaveBtn from '../../components/btn/save.vue'
import inputNum from '../../components/input/number.vue'
import switchBox from '../../components/radio/switch.vue'
import editCube from '../../components/editCubeV2.vue'
import L1 from '../../components/layout/L1.vue'
import { getapi, postapi } from '../../store/fetch'
export default {
  components: { L1, editCube, switchBox, inputNum, SaveBtn },
  data () {
    return {
      pointExchangeMustKnow: null,
      pointExchangeDirections: null,
      autoPointSend: null,
      pointratio: 100,
      pointratioOrg: 100
    }
  },
  async mounted () {
    const auto = await getapi('selections/auto_send_point')
    console.log('[auto]', auto)
    this.autoPointSend = typeof auto === 'string' ? JSON.parse(auto) : auto
    this.pointExchangeMustKnow = (await getapi('selections/pointExchangeMustKnow')) || null
    this.pointExchangeDirections = (await getapi('selections/pointExchangeDirections')) || null
    const pointratio = (await getapi('selections/pointratio') || 100)
    this.pointratio = typeof pointratio === 'string' ? JSON.parse(pointratio) : pointratio
    this.pointratioOrg = typeof pointratio === 'string' ? JSON.parse(pointratio) : pointratio
  },
  methods: {
    async updateRatio () {
      const r = await postapi('selections/pointratio', {
        key: 'value',
        data: this.pointratio
      })
      this.pointratio = typeof r === 'string' ? JSON.parse(r) : r
      this.pointratioOrg = typeof r === 'string' ? JSON.parse(r) : r
    },
    async updateP (key, key2, value) {
      const r = await postapi(`selections/${key}`, {
        key: 'value',
        data: value
      })
      this[key2] = typeof r === 'string' ? JSON.parse(r) : r
      console.log(r)
    },
    async update (key, value) {
      const r = await postapi(`selections/${key}`, {
        key: 'value',
        data: value
      })
      this[key] = r
    }
  }
}
</script>

<style lang="scss" scoped>
.g3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 0;
  height: 100%;
  &>div{
    padding: 20px 40px;
    height: 100%;
  }
  &>div:not(:last-child) {
    border-right: 1px solid #CACACA;
  }
}
.switchs {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 15px;
  .highlight {
    font-weight: 700;
    color: var(--highlight);
  }
  &>div:nth-child(2) {
    display: flex;
    gap: 20px;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    margin-block: 10px 30px;
    font-size: 20px;
    &>.switchslabel {
      width: fit-content;
      height: fit-content;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 33.5px 20px 43px;
      border-radius: 5px;
      gap: 20px;
      &::before {
        content: attr(label);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
      }
      &.min {
        width: 260px;
      }
      &.min::after{
        content: attr(after);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
        align-self: x;
      }
    }
    &>.ratiobox {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 20px;
      padding: 33.5px 20px 43px;
    }
    input[type=checkbox] {
      appearance: none;
      width: 39px;
      height: 20px;
      border-radius: 10px;
      position: relative;
        background-color: #FF8B8B;
      &:checked {
        background-color: #85B8B9;
      }
      &::before {
        content: '';
        display: inline-flex;
        width: 16px;
        height: 16px;
        position: absolute;
        left: 2px;
        right: auto;
        top: 2px;
        background-color: #FFFFFF;
        border-radius: 8px;
      }
      &:checked::before {
        right: 2px;
        left: auto;
      }
      &.invert {
        background-color: #85B8B9;
        &:checked {
          background-color: #FF8B8B;
        }
      }
    }
  }
  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-pri);
    width: -webkit-fill-available;
  }
}
</style>
